import {
  Directive,
  input,
  signal,
  inject,
  Renderer2,
  ElementRef,
  InputSignal,
  WritableSignal,
  HostAttributeToken
} from '@angular/core';

@Directive({
  selector: 'img[tdWbDefaultImage]',
  host: {
    '(error)': 'onerror()'
  }
})
export class LearnDefaultImageDirective {
  private static readonly DEFAULT_IMAGE: string = 'assets/images/learn/learn-default-image.svg';

  src: string = inject(new HostAttributeToken('src'), { optional: true });
  default: InputSignal<string> = input<string>(undefined, { alias: 'tdWbDefaultImage' });
  defaultImageClass: InputSignal<string> = input<string>(undefined, { alias: 'defaultImageClass' });
  srcDefault: WritableSignal<boolean> = signal(false);

  private readonly renderer = inject(Renderer2);
  private readonly elementRef = inject(ElementRef);

  onerror(): void {
    if (!this.srcDefault()) {
      this.srcDefault.set(true);
      const srcDefaultImage = this.hasValidDefault() ? this.default() : LearnDefaultImageDirective.DEFAULT_IMAGE;
      this.renderer.setAttribute(this.elementRef.nativeElement, 'src', srcDefaultImage);
    }
  }

  private hasValidDefault(): boolean {
    const def = this.default();
    return def !== undefined && def !== null && def !== '';
  }
}
